import { createSelector } from 'reselect';

export const routerSelector = state => state.router;
export const navigationSelector = state => state.navigation;

export const queryParamsString = createSelector(routerSelector, router => {
  if (router) {
    return router.location.search;
  } else {
    return '';
  }
});

export const isNavigating = createSelector(navigationSelector, navigation => {
  if (navigation) {
    return navigation.isNavigating;
  } else {
    return false;
  }
});

export const currentPath = createSelector(navigationSelector, navigation => {
  if (navigation) {
    return navigation.currentPath;
  } else {
    return '/';
  }
});

export const previousPath = createSelector(navigationSelector, navigation => {
  if (navigation) {
    return navigation.previousPath;
  } else {
    return '/';
  }
});



// WEBPACK FOOTER //
// ./src/store/reducers/navigation/selectors.js